<script>
// `~/stores/episode-store` lives outside the editor directory tree.
// Studio's canvas preview only needs the example upvote count; real
// vote round-trips happen on the FanWeb side. Stripped the action
// body so the element renders inside the editor boundary.
import { EpisodePageElementMixin } from "%/dynamic-component-editor/standard-pages/episode-page/episode-page-element-mixin";
import DisplayValue from "%/dynamic-component-editor/options/display-value";
import DynamicComponentActionElement from "%/dynamic-component-editor/standard-elements/action-element/DynamicComponentActionElement.vue";

export default {
  name: "EpisodeUpvoteScore",
  elementPanelSettings: {
    displayName: "Upvote Action",
    displayIcon: "bxs:upvote",
    elementGroup: "episode",
    elementType: "element",
  },
  extends: DynamicComponentActionElement,
  mixins: [EpisodePageElementMixin],
  computed: {
    myValue() {
      return this.getOptionValue(DisplayValue) === "hide" ? "" : this.entity?.upvoteCount ?? 0;
    },
  },
  methods: {
    handleClick() {
      // No-op in Studio canvas preview.
    },
  },
};
</script>
